import { combineReducers } from 'redux';
import { reducer as oidcReducer } from 'redux-oidc';

import { ApplicationActions } from './applicationActions';
import { ApplicationActionTypes } from './applicationActionTypes';
import { IApplicationState, initialApplicationState } from './applicationState';
import { groupReducer } from './group/groupReducer';
import { personReducer } from './person/personReducer';

const allReducers = combineReducers<IApplicationState>({
    groupData: groupReducer,
    oidc: oidcReducer,
    person: personReducer
});

const applicationReducer = (state = initialApplicationState, action: ApplicationActions): IApplicationState => {
    if (action.type === ApplicationActionTypes.RESET) {
        state = initialApplicationState;
    }

    return allReducers(state, action);
}

export default applicationReducer;